/**
 * Catalog text is stored with a mix of raw characters ("Winner®") and HTML
 * entities ("Danfoss&reg;"). The entity form renders literally in React and,
 * more importantly, puts a bare `&` into the cart event payload, where a parent
 * page that forwards it as a form-urlencoded body without encoding it cuts the
 * payload in half. Decode the text before it leaves the app.
 *
 * A detached <textarea> parses its content as raw text, so markup inside
 * `value` never becomes DOM nodes.
 */
let decoder: HTMLTextAreaElement | null = null;

export const decodeHtmlEntities = <T extends string | undefined>(value: T): T => {
  if (!value || !value.includes('&')) {
    return value;
  }
  if (!decoder) {
    decoder = document.createElement('textarea');
  }
  decoder.innerHTML = value;
  return decoder.value as T;
};

export default decodeHtmlEntities;
